import React, { Component } from 'react';
import checkbox from 'pretty-checkbox';
import $ from 'jquery';
import Signuppopup from './popup/Signuppopup';

class Signup extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      showEmailError: false,
      showPassError: false,
      showNameError: false,
      showCertError: false,
      showPhoneError: false,
      showMeError: false,
      showAgreeError: false,
      showEmailEmptyError: false,
      showEmailDupError: false,
      showEmailSuc: false,
      showEmailValidError: false,
      phoneNumber: "",
      validPhoneNumber: "",
      showValidPhone: false,
      complesePhoneValidPhone: false,
      isSubmit: false
    };
    this.isEmailCheck = false;

    this.emailTextObj = null;
    this.passTextObj = null;
    this.passTextObj2 = null;
    this.nameTextObj = null;
    this.fileObj = null
    this.key = "";
  }
  componentDidMount()
  {
    this.requestKey();
  }
  requestKey()
  {
    $.post('https://api.tfamily.co.kr/api/cplus/enc',{},function(data){
        let parsedData = JSON.parse(data);
        document.getElementById('EncodeData').value = parsedData.data;
    });
  }
  checkEmail(email)
  {
    let exptext = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-Za-z0-9\-]+/;
    if( exptext.test(email) == false ) {
      return false;
    }
    return true;
  }
  duplidate_email()
  {
    let self = this;

    if(!self.checkEmail(self.emailTextObj.value))
    {
      this.setState({
        showEmailValidError: true
      });
      return false;
    }

    if( this.emailTextObj.value == "" )
    {
      this.setState({
        showEmailEmptyError: true,
        showEmailError: false
      });
      return false;
    }

    $.post(
      'https://api.tfamily.co.kr/api/main/checkEmail',
      {
        email: self.emailTextObj.value
      },
      function(result){
        let parsedResult = JSON.parse(result);
        if( parsedResult.error_code == 200 )
        {
          self.isEmailCheck = true;
          self.setState({
            showEmailEmptyError: false,
            showEmailError: false,
            showEmailDupError: false,
            showEmailSuc: true
          });
        } else {
          self.setState({
            showEmailEmptyError: false,
            showEmailError: false,
            showEmailDupError: true
          });
        }
      }
    )
  }
  emailTextChg()
  {
    let self = this;
    this.isEmailCheck = false;
    self.setState({
      showEmailSuc: false,
      showEmailValidError: false
    });
  }
  submit_signUp()
  {

    let form = $('#signupForm')[0];
    let data = new FormData(form);
    let agreeBox = document.getElementById('agreeBox');
    const self = this;

    if (this.state.isSubmit) {
      return ;
    }

    if( !this.checkEmail(this.emailTextObj.value) )
    {
      this.setState({
        showEmailValidError: true
      });
      return false;
    }

    if( !this.isEmailCheck )
    {
      this.setState({
        showEmailError: true
      });
      return false;
    }

    if( this.passTextObj.value != this.passTextObj2.value )
    {
      this.setState({
        showPassError: true
      });
      return false;
    } else {
      this.setState({
        showPassError: false
      });
    }

    if( this.nameTextObj.value == '' )
    {
      this.setState({
        showNameError: true
      });
      return false;
    } else {
      this.setState({
        showNameError: false
      });
    }
    if ( this.fileObj.files.length == 0 || this.fileObj.value == null || this.fileObj.value == "" )
    {
      this.setState({
        showCertError: true
      });
      return false;
    } else {
      this.setState({
        showCertError: false
      });
    }

    if(!agreeBox.checked){
        this.setState({
            showAgreeError: true
        })
        return false;
    } else {
        this.setState({
            showAgreeError: false
        })
    }

    //showMeError
    /*
    let di = document.getElementById('di').value;
    if( di == '' ) {
        this.setState({
            showMeError: true
        });
        return false;
    } else {
        this.setState({
            showMeError: false
        });
    }
    */

    if ( this.state.complesePhoneValidPhone ) {
      this.setState({
          showMeError: false
      });
    } else {
      this.setState({
          showMeError: true
      });
      return false;
    }

    this.setState({
      isSubmit: true
    })

    $.ajax({
      type: 'POST',
      url: 'https://api.tfamily.co.kr/api/main/signup',
      data: data,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      cache: false,
      success: function(data)
      {
        self.setState({
          isSubmit: false
        })
        var pData = JSON.parse(data);
        if( pData.error_code == 200) {
            self._signupPopup.Open();
        } else if(pData.error_code==413){
          alert("이미 가입하셨습니다.");
        } else {
          alert("관리자에게 문의 부탁드립니다.");
        }

      }
    });

  }
  Auth()
  {
    let ed = document.getElementById('EncodeData').value;
    window.open('/cert/cplus_popup.php?ed=' + ed, '_blank', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');
    /*
    document.form_chk.action = "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
    document.form_chk.target = "popupChk";
    document.form_chk.submit();
    */
  }
  PhoneAuth() {

    var regExp = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
    var tel = this.state.phoneNumber;
    var self = this;
    if( !regExp.test(tel) ) {
      alert('올바른 전화번호를 기재해주세요.');
      return false;
    }

    this.setState({
      showMeError: false,
      showValidPhone: true
    });
    $.post('https://api.tfamily.co.kr/api/mobile/sendCertiSms?phone_number=' + this.state.phoneNumber, {}, function(result){
      var r = JSON.parse(result);

      if( r.error_code === 200 ) {
        self.key = r.data;
      } else {
        alert('관리자에게 문의해주세요.');
      }
    });
  }

  PhoneAuth2() {
    let self = this;
    //http://mbadmin.nebi.co.kr/api/mobile/confirmCertiSms?k=Ec8Jkagyak&v=4719
    if( this.state.validPhoneNumber !== "" ) {
      $.post("https://api.tfamily.co.kr/api/mobile/confirmCertiSms?k=" + this.key + "&v=" + this.state.validPhoneNumber, {}, function(result){
        var r = JSON.parse(result);
        //console.log(r);
        if( r.error_code === 200 ) {
          alert("인증이 완료되었습니다.")
          self.setState({complesePhoneValidPhone:true})
          //$("#phone_number").props("readonly",true);

        } else {
          alert('전달받은 4자리 숫자를 입력해주세요.');
        }
      });
    } else {
      alert('전달받은 4자리 숫자를 입력해주세요.');
    }
  }

  render() {
    let self = this;
    return(
      <div className="centralize-wrapper">
        <div className="centralize-inner">
          <div className="container">
            <form id="signupForm" name="signupForm" method="POST" encType="multipart/form-data" >
            <input type="hidden" id="di" name="di" value="NODI" />
            <div className="rowBox">
            <div className="row">
              <div className="col-xs-12 col-md-12">

                <div className="row pb30">
                  <span className="redpoint"></span>
                  <h1 className="mb0 mt5">
                    <b>회원가입</b>
                  </h1>
                  <div><span className="requirefield">*</span> 필수입력사항</div>

                  <div className="pt40 row">
                    <div className="col-md-6 col-xs-12">
                      <div className="form-group">

                          <label htmlFor="email"><span className="requirefield">*</span> <b>이메일</b></label>
                          <div className="row">
                            <div className="col-xs-9">
                              <input type="email" ref={(ref)=>{self.emailTextObj = ref}}
                                onChange={()=>{self.emailTextChg()}}
                                className="form-control loginform"
                                id="user_email" name="email"
                                placeholder="이메일을 입력해주세요."/>
                            </div>
                            <div className="col-xs-3 pl3 pr3">
                              <a onClick={()=>{self.duplidate_email()}} className="btn btn-default form-control">중복체크</a>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-xs-12 requirefield">
                              { self.state.showEmailValidError ? <div>이메일이 유효하지 않습니다</div> : <div></div> }
                              { self.state.showEmailError ? <div>이메일 중복체크 해주세요</div> : <div></div> }
                              { self.state.showEmailEmptyError ? <div>이메일을 입력해주세요</div> : <div></div> }
                              { self.state.showEmailDupError ? <div>이메일이 중복되었습니다</div> : <div></div> }
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-xs-12 passfield">
                              { self.state.showEmailSuc ? <div>사용가능한 이메일입니다</div> : <div></div> }
                            </div>
                          </div>

                      </div>

                      <div className="form-group">

                          <label htmlFor="email"><span className="requirefield">*</span> <b>비밀번호</b></label>
                          <div className="row">
                            <div className="col-xs-12">
                              <input type="password" ref={(ref)=>{self.passTextObj = ref}} className="Arial form-control loginform col-xs-10" id="user_pwd" name="passwd"
                              placeholder="암호화 후 저장합니다."/>
                            </div>
                          </div>

                      </div>

                      <div className="form-group">

                          <label htmlFor="email"><span className="requirefield">*</span> <b>비밀번호 확인</b></label>
                          <div className="row">
                            <div className="col-xs-12">
                              <input type="password" ref={(ref)=>{self.passTextObj2 = ref}} className=" Arial form-control loginform col-xs-10" id="user_pwd2"
                              placeholder="암호화 후 저장합니다."/>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-xs-12 requirefield">
                                { self.state.showPassError ? <div>비밀번호가 일치하지 않습니다</div> : <div></div> }
                            </div>
                          </div>

                      </div>

                      <div className="form-group">

                          <label htmlFor="email"><span className="requirefield">*</span> <b>이름</b></label>
                          <div className="row">
                            <div className="col-xs-12">
                              <input type="text" ref={(ref)=>{self.nameTextObj = ref}} className="form-control loginform col-xs-10" id="user_name" name="username"
                              placeholder="사용자 이름을 입력해주세요"/>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-xs-12 requirefield">
                                { self.state.showNameError ? <div>이름 확인 부탁드립니다</div> : <div></div> }
                            </div>
                          </div>
                      </div>

                      <div className="form-group">

                          <label htmlFor="email"><span className="requirefield">*</span> <b>사원증 또는 명함 사진 첨부</b></label>
                          <div className="row">
                            <div className="col-xs-12">
                              <input type="file" ref={(ref)=>{ self.fileObj=ref; }} className="form-control loginform col-xs-10" id="user_cert" name="file" placeholder="증빙서류"/>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-xs-12 requirefield">
                                { self.state.showCertError ? <div>파일 확인 부탁드립니다</div> : <div></div> }
                            </div>
                          </div>
                      </div>

                    </div>
                    <div className="col-md-6 col-xs-12">
                      <div className="form-group">

                          <label htmlFor="email"><b>휴대전화</b></label>
                          <div className="row">
                            <div className="col-xs-8">
                              <input type="text"
                               className="form-control loginform" id="phone_number" value={this.state.phoneNumber}
                               onChange={(obj)=>{
                                  this.setState({
                                    phoneNumber: obj.target.value
                                  });
                               }}
                               readOnly={this.state.complesePhoneValidPhone}
                               name="phone_number"
                               placeholder="휴대전화를 입력해주세요"/>
                            </div>
                            <div className="col-xs-4">
                                <a onClick={()=>{self.PhoneAuth()}} className="btn btn-default form-control">
                                {this.state.showValidPhone ? "재요청" : "번호 인증" }
                                </a>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-xs-12 requirefield">
                                { self.state.showMeError ? <div>휴대폰 인증 부탁드립니다</div> : <div></div> }
                            </div>
                          </div>

                      </div>

                      {this.state.showValidPhone ?
                        <div className="form-group">
                          <div className="row">
                            <div className="col-xs-8">
                              <input type="text"
                               className="form-control loginform" id="phone_valid_chk" value={this.state.validPhoneNumber}
                               onChange={(obj)=>{
                                  this.setState({
                                    validPhoneNumber: obj.target.value
                                  });
                               }}
                               name="phone_number2"
                               placeholder="인증번호를 입력해주세요"/>
                            </div>
                            <div className="col-xs-4">
                              <a onClick={()=>{self.PhoneAuth2()}} className="btn btn-default form-control">
                                인증
                              </a>
                            </div>
                          </div>
                        </div>

                        : null}


                      <div className="form-group hide">
                          <div className="row">
                            <div className="col-xs-12">
                                <a onClick={()=>{self.Auth()}} className="btn btn-default">본인 인증</a>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-xs-12 requirefield">
                                { self.state.showMeError ? <div>본인인증 부탁드립니다.</div> : <div></div> }
                            </div>
                          </div>
                      </div>

                      <div className="form-group">
                        <div className="agreebox">
                          <div className="agreetitle">
                            <div className="pretty p-icon p-round p-smooth">
                              <input type="checkbox" id="agreeBox" />
                              <div className="state p-danger">
                                <i className="icon fa fa-check"></i>
                                <label> 약관 전체 동의</label>
                              </div>
                            </div>
                          </div>
                          <div className="agreecontent">
                            <div>
                              <div>
                                <div>
                                  <label><a className="agreement" href="/agree/our.html" target="_blank"> 웹사이트 약관동의 (필수)</a></label>
                                </div>
                              </div>
                            </div>
                            <div className="pt10">
                              <div>
                                <div>
                                  <label> <a className="agreement" href="/agree/private.html" target="_blank">개인정보 수집 및 이용동의 (필수)</a></label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xs-12 requirefield">
                                { self.state.showAgreeError ? <div>이용동의 부탁드립니다</div> : <div></div> }
                          </div>
                        </div>
                      </div>
                      <div className="form-group pt15">
                        <a href="#signup" onClick={()=>{self.submit_signUp()}} className="btn btn-baru col-xs-12">
                        {this.state.isSubmit ? "회원가입 중 - 기다려주세요!" : "회원가입"}
                        </a>
                        <a href="/" className="btn btn-default form-control">취소</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
            </form>
          </div>
        </div>

        <Signuppopup ref={(ref)=>{this._signupPopup= ref;}}/>

      </div>
    );
  }
}

export default Signup;
